import * as React from "react";
import { RES_URL, IS_MOBILE } from "../../../config";
import { LinkButton } from "../Button/Button";
import { Translation } from "../../../models/models";
import { SCREEN_WIDTH } from "../../../constants";

export interface NavBarProps {
  className?: string;
  locale: Translation;
  route: string;
}

export interface NavBarState {
  isDescriptionVisible: boolean;
}

export class NavBar extends React.Component<NavBarProps, NavBarState> {
  el: HTMLDivElement;
  constructor(p: NavBarProps) {
    super(p);
    this.state = {
      isDescriptionVisible: false
    };
  }

  toggleDescription = () => {
    this.setState({
      isDescriptionVisible: !this.state.isDescriptionVisible
    });
  };

  render() {
    let props = this.props,
      state = this.state,
      locale = props.locale,
      cls = this.props.className || "";
    const currentLang = (window as any).__LOCALE__;
    let protanopiaInfoHtml = { __html: locale.protanopiaInfo };
    let deuteranopiaInfoHtml = { __html: locale.deuteranopiaInfo };
    let tritanopiaInfoHtml = { __html: locale.tritanopiaInfo };

  

    return (
      <div className={"nav-bar " + cls} ref={e => (this.el = e)}>
        {(currentLang !== "en" && (
          <a href="">
            <img
              className="nav-bar__image"
              src={RES_URL + "img/colourchange-logo-it.png"}
              alt={props.locale.altText}
            />
          </a>
        )) || (
          <a href="">
            <img
              className="nav-bar__image"
              src={RES_URL + "img/colourchange-logo-uk.png"}
              alt={props.locale.altText}
            />
          </a>
        )}

        <div className="nav-bar__buttons">
          <LinkButton
            className={
              this.props.route.includes("protanopia")
                ? "nav-bar__buttons--protanopia active"
                : "nav-bar__buttons--protanopia"
            }
            href="#/protanopia/protanopia-st-peters-basilica"
          >
            {locale.protanopiaButton}
          </LinkButton>
          <LinkButton
            className={
              this.props.route.includes("deuteranopia")
                ? "nav-bar__buttons--deuteranopia active"
                : "nav-bar__buttons--deuteranopia"
            }
            href="#/deuteranopia/deuteranopia-murano"
          >
            {locale.deuteranopiaButton}
          </LinkButton>
          <LinkButton
            className={
              this.props.route.includes("tritanopia")
                ? "nav-bar__buttons--tritanopia active"
                : "nav-bar__buttons--tritanopia"
            }
            href="#/tritanopia/tritanopia-st-peters-basilica"
          >
            {locale.tritanopiaButton}
          </LinkButton>
        </div>
        <div className="nav-bar__description-box">
          <div className="nav-bar__questionmark-button">
            {SCREEN_WIDTH.IS_SMALL() || IS_MOBILE ? (
              <i
                onClick={this.toggleDescription}
                className={`icon-ip-ccicon-question`}
              />
            ) : (
              <i className={`icon-ip-ccicon-question`} />
            )}
            <div
              className={
                this.state.isDescriptionVisible
                  ? "nav-bar__description-container active-description"
                  : "nav-bar__description-container"
              }
            >
              <i className="icon-ip-ccslider-right" />

              <div className="nav-bar__description-text">
                <p dangerouslySetInnerHTML={protanopiaInfoHtml} />
                <p dangerouslySetInnerHTML={deuteranopiaInfoHtml} />
                <p dangerouslySetInnerHTML={tritanopiaInfoHtml} />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ui/NavBar/NavBar.tsx